const SvgExpandMoreOutline = () => <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 32 32">
    <path d="m16 19.057 7.528-7.528.943.943L16 20.943l-8.472-8.471.943-.943zM0 0v-.8h-.8V0zm32 0h.8v-.8H32zm0 32v.8h.8V32zM0 32h-.8v.8H0zM0 .8h32V-.8H0zM31.2 0v32h1.6V0zm.8 31.2H0v1.6h32zM.8 32V0H-.8v32z" />
  </svg>;
export default SvgExpandMoreOutline;